import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loading-spinner',
  standalone: false,
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']

})
export class LoadingSpinnerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}